
// UI CONSTANTS
export const HEADER_HEIGHT = 60
export const DRAWER_WIDTH = 250
// APP THEME
export const DARK_MODE_THEME = 'dark'
export const LIGHT_MODE_THEME = 'light'


export const INPUT_NODE_COLOR = '#1772FF'
export const PROCESSOR_NODE_COLOR = '#00B929'
export const OUTPUT_NODE_COLOR = '#FD57FF'
export const BUFFER_NODE_COLOR = '#FF8B2E'
export const RESOURCE_NODE_COLOR = '#A15CFF'
